// TODO RR OLD
export enum NotificationType {
	UGC = "ugc",
	PRODUCT =  "product",
	SYSTEM = "system"
}
